import { apiClient } from './apiClient';

export const themeService = {
  getTheme: () => apiClient.get('/theme').then(r => r.data),
  listThemes: () => apiClient.get('/theme/list').then(r => r.data),
  createTheme: (data) => apiClient.post('/theme', data).then(r => r.data),
  updateTheme: (id, data) => apiClient.put(`/theme/${id}`, data).then(r => r.data),
  deleteTheme: (id) => apiClient.delete(`/theme/${id}`),
  setDefault: (id) => apiClient.post(`/theme/${id}/set-default`).then(r => r.data),
  uploadLogo: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiClient.post(`/theme/${id}/logo`, fd).then(r => r.data);
  },
  uploadFavicon: (id, file) => {
    const fd = new FormData();
    fd.append('file', file);
    return apiClient.post(`/theme/${id}/favicon`, fd).then(r => r.data);
  },
};
